import { render } from "./TokenInfo.vue?vue&type=template&id=beaae34c&scoped=true"
import script from "./TokenInfo.vue?vue&type=script&lang=js"
export * from "./TokenInfo.vue?vue&type=script&lang=js"

import "./TokenInfo.vue?vue&type=style&index=0&id=beaae34c&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beaae34c"]])

export default __exports__